import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'
import {Avatar} from '@components/common/base/avatar'
import {bgMixin} from '@components/main-menu/mixins'
import {noPropagate, useForceUpdate, useSyncEvent} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import {TwMenuButtonBase} from '../components/menu-button-container'
import {MenuIconButton} from '../components/menu-icon-button'
import {profilePage} from '../constants'
import {goto} from '../handlers/main-handlers'
import {useMainMenuStore} from '../main-menu-store'

const TwProfileButton = tw(TwMenuButtonBase)`
  pl-12
  rounded-4
  ${p => bgMixin(p.$active)}
`

const TwProfileText = tw.div`
  truncate
  ml-6
  text-14
  leading-4
`

const TwMenuIconButton = tw(MenuIconButton)`
  ml-auto
  h-44
  w-44
  -mr-4
  flex
  items-center
  justify-center
`

export const ProfileMenuItem = observer(() => {
  const [state, store] = useMainMenuStore()
  const {menuOpen} = state
  const userId = globals.currentUserId
  const forceUpdate = useForceUpdate()
  useSyncEvent(
    'profile',
    {debounceTime: 50, filter: globals.currentUserId},
    () => {
      forceUpdate()
    }
  )

  const gotoProfile = () => {
    goto(profilePage)
    void Tracking.send(TrackingEvent.leftPanelProfileClick)
  }
  const isProfilePage = state.currentPage === profilePage

  const toggleMenu = (e: React.MouseEvent) => {
    noPropagate(e)
    store.setMenuOpen(!menuOpen)
  }

  return (
    <TwProfileButton $active={isProfilePage} onClick={gotoProfile}>
      <Avatar hideStatus hideOutline hideHint size={20} userId={userId} />

      <TwProfileText>{Lang.msg.menu.profileHint}</TwProfileText>

      <TwMenuIconButton
        icon="IconLayoutSidebarLeftCollapse"
        size="small"
        hoverStyle="text"
        onClick={toggleMenu}
      />
    </TwProfileButton>
  )
})
